// extracted by mini-css-extract-plugin
export default {"category-tab":"casino_category-tab__dDXzp"};